import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

export const MAX_SUMMARY_HEIGHT = 358;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SummaryPopupScrollableBody: ComponentType<
	{
		useMaxHeight?: boolean;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div<{
	useMaxHeight?: boolean;
}>({
	font: token('font.body.large'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	maxHeight: ({ useMaxHeight }) => (useMaxHeight ? `${MAX_SUMMARY_HEIGHT}px` : 'unset'),
	overflowY: 'auto',
	overflowWrap: 'break-word',
	whiteSpace: 'normal',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'::-webkit-scrollbar': {
		width: '0.5rem',
		background: 'transparent',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'::-webkit-scrollbar-thumb': {
		borderRadius: token('radius.large'),
		backgroundColor: token('color.background.neutral'),
		'&:hover': {
			backgroundColor: token('color.background.neutral.hovered'),
		},
	},
});
